import React from 'react'
import Navbar from '../../common/Navbar'
import Footer from '../../common/Footer';
import { useState, useEffect } from 'react';
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

const TentitiveReport = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [filterData, setFilterData] = useState({});
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    getReportData(
      {
        mobile: "",
        month: "0",
        year: "",
        startDate: "",
        endDate: "",
        merchantId: "",
        category: ""
      },
      1
    );
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      mobile: "",
      month: "0",
      year: null,
      startDate: "",
      endDate: "",
      merchantId: "",
      category: ""
    },
    validate: (data) => {
      let errors = {};
      if (data.mobile) {
        if (data.mobile.length < 10) {
          errors.mobile = "Mobile must be in 10 digits.";
        }
      }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getReportData(data, 1);
      setFilterData(data);
    },
  });

  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);
  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

  const getReportData = async (data, pageNum) => {
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
    const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
    const searchMonth = data?.month !== "0" ? `&month=${data.month}` : "";
    const searchYear = data?.year ? `&year=${moment(data.year).format('YYYY')}` : "";
    const UsermerchantId = data?.merchantId ? `&merchantId=${data.merchantId}` : "";
    const categoryWise = data?.category ? `&category=${data.category}` : "";

      try {
        const response = await axios.get(
          Constants.baseUrl +
          `reports/retailer/monthly/tentitive/list?${searchMobile}${searchMonth}${searchYear}${UsermerchantId}${categoryWise}&sortBy=createDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        );

        const dt = response.data;
        if (dt.result === "success") {
          setReportData(dt?.output?.results);
          setTotalPages(dt?.output?.totalPages);
        } else {
          setReportData(null);
          setTotalPages(0);
        }
      } catch (err) {
        console.error("Error fetching report data:", err);
        setReportData(null);
        setTotalPages(0);
      } finally {
        setLoading(false);
      }
    }
  };

  const download = async (data) => {
    setLoading(true);
    setDownloadLoading(true);

    try {
      const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
      const UsermerchantId = data?.merchantId ? `&merchantId=${data.merchantId}` : "";
      const searchMonth = data?.month !== "0" ? `&month=${encodeURIComponent(data.month)}` : "";
      const searchYear = data?.year ? `&year=${moment(data.year).format('YYYY')}` : "";
      const categoryWise = data?.category ? `&category=${data?.category}` : "";



      const response = await axios.get(
        Constants.baseUrl +
          `reports/download/retailer/monthly/tentitiveReport?${searchMobile}${searchMonth}${searchYear}${UsermerchantId}${categoryWise}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const fileData = new Blob([response.data], { type: "text/csv" });
        saveAs(fileData, "Retailer-Claim-Report.csv");
      } else {
        swal({
          text: response.data.msg || "Download failed",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (error) {
      console.error("Download error:", error);
      swal({
        text: "An error occurred during download",
        timer: 2000,
        buttons: false,
      });
    } finally {
      setLoading(false);
      setDownloadLoading(false);
    }
  };

  const resetBtn = () => {
    searchFormik.resetForm();
    setReportData(null);
    setTotalPages(0);
    setCurrentPage(1);
    setFilterData({});
    getReportData(
      {
        mobile: "",
        month: "0",
        year: null,
        startDate: "",
        endDate: "",
        merchantId: "",
      },
      1
    );
  }

  return (
    <>
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h3 className="head1">Monthly Tentitive Report</h3>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <form onSubmit={searchFormik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                    <div className="row">
                      {/* <div className="col-md-3 col-sm-12 col-xs-12">
                      </div> */}
                      <div className="col-md-2 col-sm-12 col-xs-12">
                        <select
                          className="form-control"
                          id="month"
                          value={searchFormik.values.month}
                          onChange={searchFormik.handleChange}
                          style={{width:"auto"}}
                        >
                          <option value="0">Select Month</option>
                          <option value="1">Jan</option>
                          <option value="2">Feb</option>
                          <option value="3">Mar</option>
                          <option value="4">Apr</option>
                          <option value="5">May</option>
                          <option value="6">Jun</option>
                          <option value="7">Jul</option>
                          <option value="8">Aug</option>
                          <option value="9">Sep</option>
                          <option value="10">Oct</option>
                          <option value="11">Nov</option>
                          <option value="12">Dec</option>
                        </select>
                      </div>
                      <div className="col-md-2 col-sm-12 col-xs-12">
                        <select
                          className="form-control"
                          id="category"
                          value={searchFormik.values.category}
                          onChange={searchFormik.handleChange}
                          style={{width:"auto"}}
                        >
                          <option value="">Select Category</option>
                          <option value="WST">WST</option>
                          <option value="Pipes and Fittings">Pipes and Fittings</option>
                        </select>
                      </div>
                      <div className="col-md-2 col-sm-12 col-xs-12" style={{marginLeft:"20px"}}>
                        <div className="form-group">
                          <DatePicker
                            selected={searchFormik.values.year}
                            onChange={(date) => {
                              searchFormik.setFieldValue("year", date);
                            }}
                            showYearPicker
                            dateFormat="yyyy"
                            placeholderText="Select Year"
                            className="form-control"
                            maxDate={new Date()}
                            onKeyDown={(e) => e.preventDefault()}
                            onFocus={(e) => e.target.blur()}
                            onClick={(e) => e.preventDefault()}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <input
                            className="form-control reset"
                            type="text"
                            placeholder="Merchant Id"
                            id="merchantId"
                            value={searchFormik.values.merchantId}
                            onChange={(e) => {
                              const numericValue = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              searchFormik.handleChange({
                                target: {
                                  name: "merchantId",
                                  value: numericValue,
                                },
                              });
                            }}
                          />
                          {getSearchFormErrorMessage("merchantId")}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-3">
                    <div className="d-flex justify-content-between gap-3">
                      <button
                        type="submit"
                        className="btn btn-primary report-submit-button"
                      >
                        Search
                      </button>
                      <button
                        style={{ marginLeft: "10px" }}
                        type="button"
                        className="btn btn-primary report-submit-button"
                        onClick={resetBtn}
                      >
                        Reset
                      </button>

                      <Link
                        to=""
                        
                        className={`btn btn-primary report-submit-button mx-5${
                          downloadLoading ? "btn-opacity" : ""
                        }`}
                        onClick={() => download(searchFormik.values)}
                      >
                        {downloadLoading ? (
                          <span>
                            {" "}
                            <i className="fa fa-spinner fa-spin"></i>Export
                          </span>
                        ) : (
                          " Export"
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
              <div className="row mt-20">
                <div className="col-md-12">
                  <div className="table-responsive table--no-card">
                    <table className="table table-borderless table-striped table-earning">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>RT Code</th>
                          <th>Zone</th>
                          <th>Branch</th>
                          <th>Firm Name</th>
                          <th>Retailer Name</th>
                          <th>Retailer Mobile</th>
                          <th>distributorName</th>
                          <th>distributor Mobile</th>
                          <th>distributor Code</th>
                          <th>FS Name</th>
                          <th>FS Mobile</th>
                          <th>Fs Code</th>
                          <th>Category</th>
                          <th>WST/Pipes & Fitting totalEarned</th>
                          <th>Month</th>
                          <th>Year</th>
                        </tr>
                      </thead>
                      {reportData === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="28"
                              style={{ textAlign: "start", fontSize: "16px" }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {reportData &&
                            reportData.map((item, index) => {
                              const serialNumber =
                                (currentPage - 1) * limit + index + 1;
                              const verifiedDate = item[8]
                                ? moment(item[8]).format("DD-MM-YYYY")
                                : "";
                              return (
                                <>
                                  <tr>
                                    <td>{serialNumber}</td>
                                    <td>{item[0]}</td>
                                    <td>{item[1]}</td>
                                    <td>{item[2]}</td>
                                    <td>{item[3]}</td>
                                    <td>{item[4]}</td>
                                    <td>{item[5]}</td>
                                    <td>{item[6]}</td>
                                    <td>{item[7]}</td>
                                    <td>{item[8]}</td>
                                    <td>{item[9]}</td>
                                    <td>{item[10]}</td>
                                    <td>{item[11]}</td>
                                    <td>{item[12]}</td>
                                    <td>{item[13]}</td>
                                    <td>{item[14]}</td>
                                    <td>{item[15]}</td>
                                  </tr>
                                </>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getReportData(filterData, page);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default TentitiveReport